<script setup>
import { gsap } from 'gsap'

const props = defineProps({
  modelValue: Boolean,
  title: String,
  description: String,
  theme: String,
})
const emits = defineEmits(['update:modelValue'])
let t = null
const animDuration = 0.3
const timeout = 3000

const alert = ref(null)
const themeClasses = computed(() => {
  switch (props.theme) {
    case 'success':
      return 'bg-green-500 [&div>alert-description]:bg-green-600'
    case 'error':
      return 'bg-red-500 [&div>alert-description]:bg-red-600'
  }
})

function closeSelf() {
  clearTimeout(t)
  emits('update:modelValue', false)
}

function showAnim() {
  gsap.to(alert.value, {
    duration: animDuration,
    top: '2em',
    opacity: 1,
  })
}
function hideAnim() {
  gsap.to(alert.value, {
    onComplete: () => {
      closeSelf()
    },
    duration: animDuration,
    top: '-2em',
    opacity: 0,
  })
}

onUpdated(() => {
  if (props.modelValue) {
    showAnim()
    t = setTimeout(() => {
      hideAnim()
    }, timeout)
  }
})
</script>

<template>
  <transition
    enter-active-class="transition duration-300 ease-out"
    enter-from-class="transform -translate-y-2 opacity-0"
    enter-to-class="transform translate-y-0 opacity-100"
    leave-active-class="transition duration-300 ease-in"
    leave-from-class="transform translate-y-0 opacity-100"
    leave-to-class="transform -translate-y-2 opacity-0"
  >
    <div v-if="modelValue" ref="alert" class="fixed right-0 top-0 z-[100] w-full flex justify-end p-6">
      <div class="max-w-3xl w-full flex flex items-center rounded-lg p-4 text-white shadow-lg sm:w-auto" :class="themeClasses">
        <div class="w-64">
          <h4 class="mb-1.5 font-bold">
            {{ title }}
          </h4>
          <p class="leading-6 text-white">
            {{ description }}
          </p>
        </div>
        <div class="ml-auto h-12 w-12 flex items-center">
          <div class="alert-description rounded-full p-2 text-2xl">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" /></svg>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
